/**
 * Props accepted by {@link TaskConversationLinkIcon}.
 */
interface TaskConversationLinkIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Renders the link icon used in the task conversation header.
 *
 * @param props - Optional class name and dimensions for the icon.
 * @returns SVG icon for the conversation header link action.
 */
const TaskConversationLinkIcon = ({
  className,
  width = 16,
  height = 16,
}: TaskConversationLinkIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M6.0026 11.3346H4.66927C2.82832 11.3346 1.33594 9.84225 1.33594 8.0013C1.33594 6.16035 2.82832 4.66797 4.66927 4.66797H6.0026M10.0026 11.3346H11.3359C13.1769 11.3346 14.6693 9.84225 14.6693 8.0013C14.6693 6.16035 13.1769 4.66797 11.3359 4.66797H10.0026M4.66927 8.0013L11.3359 8.0013"
        stroke="#0056D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TaskConversationLinkIcon;
